import * as React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";


export default function ResearchAIAccordion() {
  return (
    <div className="Accordian">
    
        <Accordion style={{ backgroundColor: "white" }}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel4a-content"
            id="panel4a-header"
          >
            <Typography>
              <h3>Research AI</h3>
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              <div
                id="management-challenge"
                style={{ backgroundColor: "white", color: "black" }}
              >
                <div className="challenge-content">
                  <h1
                    className="orange text-center"
                    style={{ color: "#f49221" }}
                  >
                    Research AI
                  </h1>
                  <p>
                    <span className="orange">
                      <b>Instructions:</b>
                    </span>
                    <br />
                    We’re excited to explore the possibilities of artificial intelligence together. We have multiple projects each with different issues/challenges to tackle - You can pick any one of them (or multiple) and follow the guidelines to get started. 
                  </p>
                  <p>
  For all the challenges, relevant information, and reference material, you may
  visit the <a href="https://github.com/Project-MANAS-Research-AI" target="_blank" rel="noreferrer">
    GitHub repository
  </a>. You are encouraged to use the available resources wherever appropriate
  while attempting the challenges.
</p>

                  <hr />
                  <br />
                  <h3>
                    <strong>Submission </strong>
                  </h3>
                  <p>Candidates who do not already have a GitHub account are required to create one before proceeding. Once the account has been created, candidates may begin working on the assigned challenges.
</p>
                  <p>
                    Submit your fix to the given issues as Pull Requests to our repositories. Please refer to CONTRIBUTING.md in each project for detailed steps regarding the same.
                    
                  </p>
                  
                  <p>
                    {" "}
                    For any queries, please feel free to contact (Preferably
                    Whatsapp):{" "}
                  </p>
                  <div className="contact" align="center">
                    <p>
                      <b>Robin </b>
                      <br /> +91 7411331800
                      <br />
                    </p>
                    <p>
                      <b>Anushka </b>
                      <br /> +91 7666180091
                      <br />
                    </p>
                  </div>
                </div>
              </div>
            </Typography>
          </AccordionDetails>
        </Accordion>
    </div>
    );
}